export const allowedFileTypes: string[] = [
  "image/jpeg", // .jpg, .jpeg
  "image/png", // .png
  "application/pdf", // .pdf
];
